/* eslint-disable */
import * as util from "@/api/variable";

const state = {
    maxVariables: 0
};

const mutations = {
    SET_maxVariables: (state, value) => {
        state.maxVariables = value;
    }
};

const actions = {
    getVariableList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getVariableList(dataParams).then(response => {
                if (response.data && typeof response.data.maxVariables != "undefined") {
                    commit("SET_maxVariables", response.data.maxVariables);
                }
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createVariable({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createVariable(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getVariableDetail({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getVariableDetail(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateVariable({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.updateVariable(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteVariable({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.deleteVariable(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/variable.js